import React from "react";
import { useHistory } from "react-router-dom";
import CaretDefault from "../icons/caret-default.svg";

import { useCommonContext } from "../../context/common-context";

import "../help/help.scss";
import { routes, routeTitle } from "../help/constants";

const Faq = ({ faq }) => {
  const {
    bannerCategories,
    appData: { banner: bannerName },
  } = useCommonContext();
  const history = useHistory();
  const childFaqRoutes = Object.values(routes);

  const navigateTo = ({ category, id }) => {
    const routeName = getIdToRoute(category[0]);
    history.push(`/faq-detail/${routeName}/${id}`);
  };

  const getIdToRoute = (catId) => {
    const pathname = window.location.pathname.split("/").pop();
    let category;
    if (childFaqRoutes && childFaqRoutes.includes(pathname)) {
      const title = routeTitle[pathname];
      category = bannerCategories.find((cat) => cat.title === title);
    } else {
      category = bannerCategories.find(({ id }) => id === catId);
    }
    const routeKey = Object.keys(routeTitle).find(
      (title) => routeTitle[title] == category.title
    );
    return routeKey;
  };

  const FaqItem = ({ list }) => {
    const banner = bannerName.charAt(0).toUpperCase() + bannerName.slice(1);
    const faqQuestion = list.question.replaceAll("[banner]", banner);
    const lowerCaseBanner = banner.toLowerCase();
    return (
      <div
        className={
          "cursor-pointer faq-list-block mr-2 mt-3 pb-2 row category-" +
          lowerCaseBanner
        }
        role="button"
        tabIndex="0"
        aria-label={faqQuestion}
        onClick={() => navigateTo(list)}
      >
        <div className="col">
          <div className="row">
            <h4
              className="col-12 font-weight-600 faq-question"
              aria-label={faqQuestion}
              role="link"
            >
              {faqQuestion}
            </h4>
          </div>
        </div>
        <div className="text-right chevron-icon">
          <img alt="Caret Image" className="ml-2" src={CaretDefault} />
        </div>
      </div>
    );
  };

  return faq.map((list) => <FaqItem list={list} />);
};

export default Faq;
